export default "__VITE_ASSET__uTTocBGK__"